import ExternalLink from "@/components/ExternalLink";
import SimpleTable from "@/components/SimpleTable";
import { Button } from "@/components/ui/button";
import { handleCompanyName } from "@/lib/handleName";
import { AssessmentProgress } from "@/schema/AssessmentProgress";
import ConfirmReassessmentDialog from "@/src/console/(auth)/(confirm-assessments)/re-assessments/_components/ConfirmReassessmentDialog";
import useAssessmentDialog from "@/src/console/(auth)/(confirm-assessments)/re-assessments/_hooks/useAssessmentDialog";
import { useTranslation } from "react-i18next";

interface ReassessmentTableProps {
  data: AssessmentProgress[];
  isLoading: boolean;
}

function ReassessmentTable({ data, isLoading }: ReassessmentTableProps) {
  const { t } = useTranslation();
  const { setDialog } = useAssessmentDialog();

  return (
    <>
      <SimpleTable
        isLoading={isLoading}
        data={data}
        columns={[
          {
            key: "name",
            label: t("name"),
            render: ({ id, company_name }) => (
              <div className="flex h-[42px] items-center">
                <span>{handleCompanyName(id, company_name)}</span>
              </div>
            ),
          },
          {
            key: "score",
            label: t("score"),
            render: ({ score }) => (
              <div className="flex h-[42px] items-center">
                <span>{score ?? "--"}</span>
              </div>
            ),
          },
          {
            key: "action-assessment-report",
            label: "",
            render: ({ id }) => (
              <ExternalLink
                label={t("re-assessment-report")}
                url={`/console/assessment-results/${id}?isFirstTime=false`}
              />
            ),
          },
          {
            width: "200px",
            key: "action-confirm",
            label: "",
            render: (assessmentProgress) => (
              <Button
                onClick={() => {
                  setDialog({
                    type: "confirm",
                    assessment: assessmentProgress,
                  });
                }}
                variant="outline"
              >
                {t("confirm")}
              </Button>
            ),
          },
        ]}
      />
      <ConfirmReassessmentDialog />
    </>
  );
}

export default ReassessmentTable;
